import { Component } from '@theme/component';
import { morphSection } from '@theme/section-renderer';

/**
 * Swatches that switch between sibling products by fetching the full product page and morphing
 * the main section (no `section_id` query param — avoids Section Rendering API URL shape).
 */
class ColorFamilyPicker extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('change', this.#handleChange);
  }

  /**
   * @param {Event} event
   */
  #handleChange = async (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.matches('[data-color-family-input]')) return;

    const productUrl = target.dataset.productUrl;
    if (!productUrl) return;

    const labelEl = this.querySelector('[data-selected-color-label]');
    if (labelEl) labelEl.textContent = target.value;

    const variantPicker = this.closest('variant-picker');
    const summaryValueEl =
      variantPicker?.querySelector('[data-color-summary-value]') ??
      this.closest('.shopify-section')?.querySelector('[data-color-summary-value]');
    if (summaryValueEl) summaryValueEl.textContent = target.value;

    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const url = new URL(productUrl, window.location.origin);

    try {
      const response = await fetch(url.href);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      await morphSection(sectionId, html, 'full');

      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (error) {
      console.error('Color family picker:', error);
      window.location.href = url.href;
    }
  };
}

if (!customElements.get('color-family-picker')) {
  customElements.define('color-family-picker', ColorFamilyPicker);
}
